module.exports = __webpack_public_path__ + "assets/acquia-cloud-platform.11e6bcf5.svg";